import styled, { css } from 'styled-components';

import * as Base from './base';

export const CarouselContainer = styled(Base.CarouselContainer)`
  padding-block-start: 0;
  padding-block-end: 10px;
  padding-inline: 96px;
`;

export const TileLabel = styled(Base.TileLabel)`
  color: #767676;
  font-size: 0.875rem;
`;

export const TileImageWrapper = styled(Base.TileImageWrapper)`
  text-align: center;

  > img {
    height: 60px;
    filter: grayscale(100%);
  }
  > svg {
    filter: grayscale(100%);
  }
`;

const tileStyles = css`
  &:hover ${TileImageWrapper} {
    > img {
      filter: grayscale(0);
    }
    > svg {
      filter: grayscale(0);
    }
  }
  &:hover ${TileLabel} {
    color: ${Styles.color.highlight};
  }
`;

export const TileExternal = styled(Base.TileExternal)`
  ${tileStyles}
`;

export const TileWithoutCurrent = styled(Base.TileWithoutCurrent)`
  ${tileStyles}
`;

export const Tile = styled(TileWithoutCurrent)`
  &[aria-current='page'] * {
    color: ${Styles.color.tertiary};

    &::before {
      content: '';
      height: 2px;
      position: absolute;
      inset-block-end: 0;
      background-color: ${Styles.color.highlight};
    }
  }
  &[aria-current='page'] ${TileImageWrapper} {
    > img {
      filter: grayscale(0);
    }
  }
  &[aria-current='page'] ${TileLabel} {
    color: ${Styles.color.highlight};
  }
`;

export const TileButton = styled(Base.TileButton)`
  &:hover ${TileImageWrapper} {
    > img {
      filter: grayscale(0);
    }
  }

  &:hover ${TileLabel} {
    color: ${Styles.color.highlight};
  }
`;

export * from './base';
